import { Injectable } from '@angular/core';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './broker-search.actions';

@Injectable({
	providedIn: 'root',
})
export class BrokerSearchDispatch {
	@Dispatch()
	Search = (
		searchValue: string,
		brokerageId?: string,
		cardId?: string,
	): actions.Search => new actions.Search({ searchValue, brokerageId, cardId });

	@Dispatch()
	resetBrokerSearch = () => new actions.Reset();

	@Dispatch()
	searchBrokers = (searchValue: string): actions.Reset =>
		new actions.Search({ searchValue });
}
